<template>
  <div class="ps-otp">
    <input
      v-for="(b, i) in boxes"
      :key="i"
      v-model="boxes[i]"
      :ref="(el) => { if (el) refs[i] = el }"
      class="ps-otp__box brutal-2 rounded-xl bg-cream focus:bg-white"
      type="text"
      inputmode="numeric"
      maxlength="1"
      autocomplete="one-time-code"
      :aria-label="(i + 1).toString()"
      @input="onInput(i, $event)"
      @keydown="onKeydown(i, $event)"
      @paste="onPaste(i, $event)"
    />
  </div>
</template>

<script>
export default {
  name: "BrutalOtpInput",
  data: () => ({
    boxes: ["", "", "", "", "", ""],
    refs: [],
  }),
  methods: {
    onInput(i, e) {
      this.$set(this.boxes, i, e.target.value.replace(/\D/g, ""));
      if (this.boxes[i] && i < 5) this.refs[i + 1]?.focus();
      if (this.value.length === 6) this.$emit("complete", this.value);
    },
    onKeydown(i, e) {
      if (e.key === "Backspace" && !this.boxes[i] && i > 0) {
        this.refs[i - 1]?.focus();
      }
    },
    onPaste(i, e) {
      e.preventDefault();
      const digits = (e.clipboardData.getData("text") || "")
        .replace(/\D/g, "")
        .slice(0, 6)
        .split("");
      digits.forEach((d, j) => {
        if (this.boxes[j] !== undefined) this.$set(this.boxes, j, d);
      });
      const next = Math.min(digits.length, 5);
      if (this.refs[next]) this.refs[next].focus();
      if (this.value.length === 6) this.$emit("complete", this.value);
    },
  },
  computed: {
    value() {
      return this.boxes.join("");
    },
  },
};
</script>

<style scoped>
.ps-otp {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.ps-otp__box {
  width: 52px;
  height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: 900;
  color: var(--ps-ink);
  transition: background-color 0.15s ease;
}
.ps-otp__box:focus {
  outline: none;
  background: #fff;
}
</style>
